import React from 'react'
import { GetServerSideProps } from 'next'
import { createCombinedServerSideProps } from '../../src/utils/server/page-props'
import { getLayout } from '../../src/layouts/MainLayout'
import { ConsumerPage } from '../../src/model'
import { useRouter } from 'next/router'
import { OrderDetailPanel } from '../../src/component/OrderDetailPanel'
import { useTranslation } from 'next-i18next'
import { Head } from '../../src/component'

const I18N_NAMESPACE = ['common', 'index', 'orders', 'payments', 'account', 'cardScan', 'dispute', 'ach']

const OrderDetailPage: ConsumerPage = () => {
  const router = useRouter()
  const { id } = router.query
  const { t } = useTranslation(I18N_NAMESPACE)
  const orderId = String(id)
  const pageTitle = `${t('orders:order')} ${orderId} | ${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <OrderDetailPanel orderId={orderId} />
    </>
  )
}

OrderDetailPage.getLayout = getLayout()

export const getServerSideProps: GetServerSideProps = createCombinedServerSideProps(I18N_NAMESPACE)
export default OrderDetailPage
